import type { StairCatalogSettings } from "building-types/settings/stairCatalogSettings";
import type { StairSetting } from "building-types/stairs/stairTypes";
import type { FeatureSet } from "common/constants/features";
import type { Table } from "common/data/table";
import objectFilter from "common/utils/objectFilter";
import { defaultStairSettings, defaultStairSettingsKey } from "./stairConstants";

export const builtInStairSettings: Table<StairSetting> = {
  [defaultStairSettingsKey]: defaultStairSettings,
};

/**
 * Dual-read helper (BDG-2943): with `settingsToCatalogs` on, `doc.stairCatalog` entries win over
 * the legacy settings-nested `stairSettingsTable` on id collision; with the flag off (or no doc
 * table entries yet), resolution is identical to the pre-migration behavior.
 */

export function getStairCatalog(
  stairCatalogSettings: StairCatalogSettings | undefined,
  stairCatalog?: Table<StairSetting>,
  enabledFeatures?: FeatureSet,
): Table<StairSetting> {
  if (enabledFeatures?.settingsToCatalogs && stairCatalog) {
    const legacySettings = objectFilter(
      stairCatalogSettings?.stairSettingsTable ?? {},
      (entry) => !(entry.id in builtInStairSettings),
    );
    return { ...legacySettings, ...stairCatalog };
  }

  return stairCatalogSettings?.stairSettingsTable ?? {};
}
